import { IModel } from '@/@types/models/model';

const Upitnik: IModel = {
  title: 'Upitnik',
  apiPath: 'groblja/upitnik',
  forms: {
    insert: {
      fields: ['ime', 'prezime', 'oib', 'kontakt', 'ulica', 'mjesto', 'ptt', 'drzava', 'napomena', 'privitci'],
      validator: 'validateUpitnikOdgovor',
    },
  },
  listViews: {
    default: {
      fields: [],
    },
  },
  fields: [
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'groblja:upitnik.ime',
      type: 'text',
      validation: {
        required: true,
        maxLength: 100,
      },
    },
    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'groblja:upitnik.prezime',
      type: 'text',
      validation: {
        required: true,
        maxLength: 100,
      },
    },
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'groblja:upitnik.oib',
      type: 'text',
      validation: {
        regex: 'oib',
      },
    },
    {
      title: 'kontakt',
      source: 'kontakt',
      ttoken: 'groblja:upitnik.kontakt',
      tooltip: 'groblja:upitnik.kontakt_hint',
      type: 'text',
      validation: {
        required: true,
        maxLength: 100,
      },
    },
    {
      title: 'ulica',
      source: 'ulica',
      ttoken: 'groblja:upitnik.ulica',
      type: 'text',
      validation: {
        maxLength: 100,
      },
    },
    {
      title: 'mjesto',
      source: 'mjesto',
      ttoken: 'groblja:upitnik.mjesto',
      type: 'text',
      validation: {
        maxLength: 100,
      },
    },
    {
      title: 'ptt',
      source: 'ptt',
      ttoken: 'groblja:upitnik.ptt',
      type: 'wholenum',
      validation: {
        minValue: 0,
        maxValue: 99999,
      },
    },
    {
      title: 'drzava',
      source: 'drzava',
      ttoken: 'groblja:upitnik.drzava',
      type: 'text',
      validation: {
        maxLength: 100,
      },
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'groblja:upitnik.napomena',
      type: 'multiline',
      rows: 3,
      maxRows: 6,
      validation: {
        maxLength: 512,
      },
    },
    {
      title: 'privitci',
      source: 'privitci',
      ttoken: 'groblja:upitnik.privitci',
      tooltip: 'groblja:upitnik.privitci_hint',
      type: 'document',
      accept: 'images_pdf',
      maxFiles: 3,
      maxSize: 10 * 1024 * 1024,
    },
  ],
};

export default Upitnik;
